import { render, staticRenderFns } from "./KpiOverzicht.vue?vue&type=template&id=53fa9846"
import script from "./KpiOverzicht.vue?vue&type=script&lang=js"
export * from "./KpiOverzicht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports